let env = process.env.NODE_ENV || 'development';
let configEnv = process.env.CONFIG_ENV || 'local';

let mode = $qsObj.mode || 'normal';
if (location.pathname === '/ces') {
    mode = 'ces';
} else if (location.pathname === '/normal') {
    mode = 'normal';
}
// mode = 'ces';
// mode = 'normal';
document.body.classList.add('mode-'+mode);

let foodConfig = {
    normal: {
        // poi3dMid: '1008936224792019068', // 大董（南新仓店）
        // poi2dSearch: '大董（南新仓店）', // 14878692
        // poi2dAutoJump: '1008937295522328644', // 北京胡同烤鸭
        // poi3dMid: '1008936946967273505', // 小象生鲜
        // poi2dSearch: '小象生鲜（南湖东园店）',
        // poi2dAllValue: 5,

        // $qsObj.backPoi 存在时，启用备用poi
        // poi3dMid: '1008938503825825874', // 眉州东坡酒楼（民族园店）
        poi3dMid: $qsObj.backPoi ? '1008936154810036313' : '1008938503825825874', // 眉州东坡酒楼（民族园店）
        poi2dSearch: $qsObj.backPoi ?  '眉州东坡（王府井店）' :'眉州东坡酒楼（民族园店）',
        poi2dSearchCity: '北京',
        poi2dAllValue: 5,
        // 注意 标签的ID具有不稳定性
        poi2dAutoHighLightListObj: [
            {"name": "性别分布", "type": "Tag.TagInfo"},
            {"name": "年龄分布", "type": "Tag.TagInfo"},
            {"name": "消费水平分布", "type": "Tag.TagInfo"},
            {"name": "标签", "type": "Tag.TagInfo"},
            {"name": "环境偏好", "type": "Tag.TagInfo"},
            {"name": "推荐菜", "type": "Tag.TagInfo"},
        ],
        // poi2dAutoJump: '1008936853832765530' // 峨嵋酒家（牡丹园店）
        poi2dAutoJump: '1008938154352218169' // 川军本色（双榆树双安店）
    },
    ces: {
        poi3dMid: '1008936952222736517', // 永利自助餐 // 1008937255743537220凯撒
        poi2dAllValue: 10,
        poi2dAutoJump: '1008937255743537220', // Bacchanal Buffet  凯撒酒店自助餐
        poi2dSearch: 'The Buffet at Wynn',
    },
    mode,
};

let Config = foodConfig[mode];

let $lang = mode === 'ces' ? 'en' : 'zh';
Config.$lang = $lang;
Config.mode = mode;
window['$lang'] = $lang;

console.log('food-config:', Config);
export default Config;
